import { apiGet, apiPost } from './client';
import { routes } from './routes';
import { isHtmlFile } from '../../utils/path';

export async function listFiles(domain) {
  const response = await apiPost(routes.editor.list, { domain });
  const data = await response.json();
  return data.fileList;
}

export async function fetchFileContent(file, domain) {
  const isHtml = isHtmlFile(file);
  const route = isHtml ? routes.editor.proxy : routes.editor.code;

  const response = await apiGet(route, { file, domain });

  if (isHtml) {
    const blob = await response.blob();
    return await blob.text();
  } else {
    const data = await response.json();
    return data.code;
  }
}

export async function publishFile(file, code, domain) {
  const response = await apiPost(routes.editor.publish, {
    file,
    code,
    domain
  });
  return response.ok;
}
